<template>
  <div class="pa-4 mb-8">
    <v-row justify="center">
      <h2 class="display-1 pb-4">{{ step1.title }}</h2>
    </v-row>
    <v-row justify="center">
      <v-col cols="8">
        <v-text-field
          autofocus
          hide-details
          v-model="title"
          :placeholder="step1.placeholder"
          @keypress.enter="$emit('next')"
          ref="input"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="8" class="caption">
        <strong>Examples:</strong>
        <p v-for="example in step1.examples" :key="example" class="mb-0">{{ example }}</p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ['step1', 'value', 'focus'],
  watch: {
    focus: function(n) {
      if (n) {
        this.$refs.input.focus();
      }
    }
  },
  computed: {
    title: {
      get: function() {
        return this.value;
      },
      set: function(v) {
        this.$emit('input', v);
      }
    }
  }
};
</script>

<style></style>
